import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import dayjs from "dayjs";
import ScoreTable1Header from "./ScoreTable1Header";
import ScoreTable1Body1 from "./ScoreTable1Body1";
import { watch, reactive, toRefs, computed, onMounted } from "vue";
import apis from "@/api";
import ScoreTable1Body2 from "./ScoreTable1Body2";
import { useRoute } from "vue-router";
export default {
  name: "ScoreTable1",
  components: {
    ScoreTable1Body2,
    ScoreTable1Body1,
    ScoreTable1Header
  },
  setup(props, context) {
    const route = useRoute();
    const data = reactive({
      demandId: route.query.demandId,
      designAccount: route.query.designAccount,
      designName: route.query.designName,
      topId: route.query.topId,
      positionId: route.query.positionId,
      confirm: -1,
      examTime: dayjs().format('YYYY-MM-DD'),
      examinee: '',
      examiner: '',
      fillRate: '',
      score1: {},
      score2: {}
    });
    const submit = () => {
      if (data.confirm == 0) {
        const param = {
          demandId: route.query.demandId,
          designAccount: route.query.designAccount,
          positionId: route.query.positionId,
          confirm: 1,
          examinee: data.examinee
        };
        apis.confirm(param).then(res => {
          if (res.success) {
            ElMessage.success('服务考核评估表确认成功');
            queryScore();
          } else {
            ElMessage.error(res.msg);
          }
        });
      } else {
        const param = {
          ...data.score1,
          ...data.score2,
          scoreSum1: scoreSum1.value,
          scoreSum2: scoreSum2.value,
          scoreSum: scoreSum.value,
          examTime: data.examTime,
          examinee: data.examinee,
          examiner: data.examiner,
          fillRate: data.fillRate,
          demandId: route.query.demandId,
          designAccount: route.query.designAccount,
          designName: route.query.designName,
          topId: route.query.topId,
          positionId: route.query.positionId
        };
        if (checkParam(param)) {
          param.confirm = 0;
          apis.addScore1(param).then(res => {
            if (res.success) {
              ElMessage.success('服务考核评估表保存成功');
              queryScore();
            } else {
              ElMessage.error(res.msg);
            }
          });
        }
      }
    };
    const checkParam = param => {
      console.log(param);
      let count = 0;
      for (var key in param) {
        count++;
        if (!param[key]) {
          if (key == 'examiner') {
            ElMessage.error('考核人签字不能为空');
            return false;
          } else if (key == 'examinee') {
            if (data.confirm == 1) {
              ElMessage.error('被考核单位确认签字不能为空');
              return false;
            }
          } else {
            ElMessage.error('存在未评分项，请检查');
            return false;
          }
        }
      }
      console.log(count);
      if (count < 33) {
        ElMessage.error('存在未评分项，请检查');
        return false;
      }
      return true;
    };
    const scoreSum = computed(() => {
      const ss1 = scoreSum1.value ? scoreSum1.value : 0;
      const ss2 = scoreSum2.value ? scoreSum2.value : 0;
      return ss1 + ss2;
    });
    const scoreSum1 = computed(() => {
      var totalScore = eval(Object.values(data.score1).join("+"));
      return totalScore;
    });
    const scoreSum2 = computed(() => {
      var totalScore = eval(Object.values(data.score2).join("+"));
      return totalScore;
    });
    const queryScore = () => {
      const param = {
        demandId: route.query.demandId,
        designAccount: route.query.designAccount,
        positionId: route.query.positionId
      };
      apis.getScore1(param).then(res => {
        if (res.success && res.data) {
          for (var key in res.data) {
            if (key.startsWith('score1')) {
              data.score1[key] = res.data[key];
            }
            if (key.startsWith('score2')) {
              data.score2[key] = res.data[key];
            }
          }
          data.examTime = res.data.examTime;
          data.examinee = res.data.examinee;
          data.examiner = res.data.examiner;
          data.fillRate = res.data.fillRate;
          data.confirm = res.data.confirm;
        }
      });
    };
    onMounted(() => {
      queryScore();
    });
    return {
      ...toRefs(data),
      scoreSum,
      scoreSum1,
      scoreSum2,
      submit
    };
  }
};